import { ChoiceList, FormLayout } from '@shopify/polaris'
import { useEffect, useState } from 'react'

import { AdaptiveModal } from './AdaptiveModal'
import { DialogActivator, NonEmptyArray } from './helpers'

export type TableColumnChoices = { label: string; value: string; disabled?: boolean }

export const TableColumnSelectorModal = ({
  activator,
  columns,
  onChange,
  choices,
}: {
  activator: DialogActivator
  columns: string[]
  onChange: (columns: NonEmptyArray<string>) => any
  choices: TableColumnChoices[]
}) => {
  const [draftColumns, setDraftColumns] = useState<string[]>(columns)

  useEffect(() => {
    setDraftColumns(columns)
  }, [columns, activator.showCounter])

  return (
    <AdaptiveModal
      open={activator.open}
      onClose={activator.close}
      title="Edit columns"
      primaryAction={{
        content: 'Save',
        onAction: () => {
          onChange(draftColumns as NonEmptyArray<string>)
          activator.close()
        },
      }}
      secondaryActions={[{ content: 'Cancel', onAction: activator.close }]}
    >
      <AdaptiveModal.Section>
        <FormLayout>
          <ChoiceList
            title="Columns"
            titleHidden={true}
            allowMultiple
            choices={choices}
            selected={draftColumns}
            onChange={setDraftColumns}
          />
        </FormLayout>
      </AdaptiveModal.Section>
    </AdaptiveModal>
  )
}
